module.exports = __webpack_public_path__ + "24aab533f87e7b434be5fa5b1684975c.svg";


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/scss/theme/font-open-sans/fonts/Semibold/OpenSans-Semibold.svg
// module id = 371
// module chunks = 0